<!-- BEGIN: Aside Menu -->
<div [class]="'kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid kt-aside-menu-' + currentTheme.baseSettings.menu.asideSkin" id="kt_aside_menu_wrapper">
  <div #asideMenu ktMenu [options]="menuOptions" perfectScrollbar="{wheelPropagation: false}"
    [ngStyle]="{'max-height': '90vh', 'position': 'relative'}" id="kt_aside_menu" class="kt-aside-menu"
    [attr.data-ktmenu-vertical]="1" [attr.data-ktmenu-scroll]="ui.getIsMenuScrollable() ? 1 : 0"
    [attr.data-ktmenu-dropdown]="ui.isSubmenuToggleDropdown() ? 1 : 0" (mouseenter)="mouseEnter($event)"
    (mouseleave)="mouseLeave($event)" [class]="ui.getLeftAsideClass()">
    <ul class="kt-menu__nav" class="kt-menu__nav">
      @if (currentTheme.baseSettings.menu.searchActive) {
        <li  class="kt-menu__item kt-menu__item--submenu"
          data-ktmenu-submenu-toggle="hover">
          <menu-search-bar></menu-search-bar>
        </li>
      }
      <ng-container [ngTemplateOutlet]="menuListTemplate"></ng-container>
    </ul>
  </div>
</div>
<!-- END: Aside Menu -->

<!-- </div> -->

<ng-template #menuListTemplate>
  @for (child of menu.items; track child) {
    @if (showMenuItem(child)) {
      <ng-container [ngTemplateOutlet]="mMenuItem"
      [ngTemplateOutletContext]="{ item: child, parentItem: menu }"></ng-container>
    }
  }
</ng-template>

<ng-template #mMenuItem let-item="item" let-parentItem="parentItem">
  @if (showMenuItem(item)) {
    <li class="{{ui.getSideBarMenuItemClass(item, isMenuItemIsActive(item))}}"
      data-ktmenu-submenu-toggle="hover">
      <!-- if menu item hasn't submenu -->
      @if (!item.items.length && !item.external) {
        <a [queryParams]="item.parameters" [routerLink]="item.route"
          class="kt-menu__link">
          <ng-container [ngTemplateOutlet]="mMenuItemText"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>
      }
      @if (!item.items.length && item.external) {
        <a [attr.href]="item.route" target="_blank"
          class="kt-menu__link kt-menu__toggle">
          <ng-container [ngTemplateOutlet]="mMenuItemText"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>
      }
      <!-- if menu item has submenu child  -->
      @if (item.items.length) {
        <a href="javascript:;" class="kt-menu__link kt-menu__toggle">
          <ng-container [ngTemplateOutlet]="mMenuItemText"
          [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>
      }
      <!-- if menu item has submenu child then recursively call new menu item component -->
      @if (item.items.length) {
        <div class="kt-menu__submenu">
          <span class="kt-menu__arrow"></span>
          <ul class="kt-menu__subnav">
            @for (child of item.items; track child) {
              <ng-container [ngTemplateOutlet]="mMenuItem"
              [ngTemplateOutletContext]="{ item: child, parentItem: item }"></ng-container>
            }
          </ul>
        </div>
      }
    </li>
  }
</ng-template>

<ng-template #mMenuItemText let-item="item" let-parentItem="parentItem">
  <span class="kt-menu__item-here"></span>
  <!-- if menu item has icon -->
  @if (item.icon) {
    <span class="kt-menu__link-icon">
      @if (item.icon && item.route) {
        <img class="kt-menu__link-icon mr-15" width="30" height="30" src="/assets/common/images/sidebar-icons/{{item.icon}}" alt="{{ item.name | localize }}" />
      }
      @if (item.icon && !item.route) {
        <i class="kt-menu__link-icon" [ngClass]="item.icon"></i>
      }
    </span>
  }

  @if (!item.badge) {
    <!-- menu item title text -->
    <span class="kt-menu__link-text">
      {{item.name | localize}}
    </span>
  } @else {
    <!-- menu item with badge -->
    <span class="kt-menu__link-title">
      <span class="kt-menu__link-wrap">
        <span class="kt-menu__link-text">
          {{item.name | localize}}
        </span>
        <span class="kt-menu__link-badge">
          <span class="kt-badge" [ngClass]="item.badge.type">{{item.badge.value}}</span>
        </span>
      </span>
    </span>
  }


  <!-- if menu item has submenu child then put arrow icon -->
  @if (item.items.length) {
    <i class="kt-menu__ver-arrow la la-angle-right"></i>
  }
</ng-template>
<!-- END: Left Aside -->
